module.exports = "/assets/data/46e2d1ec43c3100110e0c2050015b8bb-DD7.data.json";